import styled from 'styled-components';

export const VideoSectionContainer = styled.div`
  .headerImage {
    width: 100%;
    margin-bottom: -6px;
    margin-top: ${(props) => (props.lactoMama ? '18px' : '0')};
  }
  padding: ${(props) => (props.lactoMama ? '' : '0 0px 0 12px')};
  margin: ${(props) =>
    props.clothDiaper
      ? '50px auto 0px'
      : props.clothDiaper
        ? '50px auto 30px'
        : '30px 0'};
  @media (max-width: 768px) {
    margin: 35px auto 0px;
    margin-top: ${(props) => (props.removeBottomMargin ? '0px' : '')};
  }
  h3 {
    font-size: clamp(20px, 3vw, 24px);
    color: rgba(0, 0, 0, 0.87);
    font-weight: bold;
    // text-transform: uppercase;
    margin-bottom: 30px;
    text-align: left;
  }
  .userSpeak {
    display: none;
    @media (max-width: 768px) {
      display: block;
      font-size: clamp(22px, 2vw, 48px);
      font-weight: 600;
      text-align: center;
      color: #675b5a;
    }
    span {
      color: #7e5c5c;
    }
  }
  .userSpeakDesktop {
    display: block;
    font-size: clamp(28px, 2vw, 48px);
    font-weight: 600;
    text-align: center;
    color: #675b5a;
    span {
      color: #7e5c5c;
    }
    @media (max-width: 768px) {
      display: none;
    }
  }
  .flexContainer {
     background: ${(props) => (props.lactoMama ? `${props.tabThemeColor || '#498A5B'}` : '')};
  }
  .flex {
    display: flex;
    overflow-x: scroll;
    align-items: flex-start;
    max-width: 100%;
    margin: 0 auto;
   
    background: ${(props) => (props.lactoMama ? `${props.tabThemeColor || '#498A5B'}` : '')};
    gap: ${(props) => (props.clothDiaper ? '25px' : '16px')};

    @media (max-width: 768px) {
      gap: ${(props) =>
        props.store
          ? '4px'
          : props.lactoMama
            ? '0'
            : props.stretchMarks
              ? '12px'
              : '25px'};
    }
    &::-webkit-scrollbar {
      display: none;
    }
  }
  .flexItem {
    flex-basis: ${(props) => (props.store ? '44%' : '56%')};
    flex-shrink: 0;
    margin-left: ${(props) => (props.lactoMama ? '16px' : '')};
    margin-top: ${(props) => (props.lactoMama ? '12px' : '')};
    margin: ${(props) => (props.store ? '3px' : '')};
    @media (min-width: 768px) {
      flex-basis: ${(props) =>
        props.store
          ? '20%'
          : props.clothDiaper
            ? '23%'
            : props.lactoMama
              ? '26%'
              : '37%'};
    }
  }
  .caption {
    padding: 6px 0px;
    line-height: 1.2;
    font-size: 11px;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.77);
    span {
      font-size: 11px;
      font-weight: 600;
      opacity: 0.87;
      color: rgba(0, 0, 0, 1);
    }
  }
  @media (min-width: 768px) {
    padding: 0;
    width: ${(props) =>
      props.store ? '72%' : props.clothDiaper ? '84%' : '100%'};
  }
  .userProfile {
    display: flex;
    align-items: center;
    gap: 10px;
  }
`;

export const VideoWithGif = styled.div`
  position: relative;
  border-radius: 8px;
  video {
    width: 100%;
    border-radius: 8px;
  }

  .bottomOverlay {
    position: absolute;
    padding: 10px;
    bottom: 4px;
    border-bottom-right-radius: 8px;
    border-bottom-left-radius: 8px;
    width: 100%;
    left: 0;
    background: linear-gradient(to bottom, transparent, rgba(0, 0, 0, 0.78));
    display: flex;
    align-items: center;
    justify-content: space-between;
    img {
      width: 16px;
    }

    .viewCount {
      display: flex;
      align-items: center;
      gap: 6px;
      color: #fff;
      font-size: 14px;
      font-weight: 500;
    }
  }
  .hidden {
    display: none;
  }
  .soundIconContainer {
    position: absolute;
    width: 100%;
    height: 100%;
    inset: 0;
    img {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      width: 36px;
      filter: drop-shadow(1px 1px 14px black);
      transition: opacity 0.4s linear;
      &.sound {
        opacity: 1;
      }
      &.noOpacity {
        opacity: 0;
      }
    }
  }
`;

export const ImageGridContainer = styled.div`
  padding: 0 16px;
  margin: 20px 0;
  h3 {
    font-size: clamp(20px, 3vw, 24px);
    color: rgba(0, 0, 0, 0.87);
    font-weight: bold;
    margin-bottom: 16px;
    text-align: center;
  }
  .grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
  }
  @media (min-width: 768px) {
    padding: 0;
  }
`;

export const DiaperVideoContainer = styled.div`
  width: 100%;
  position: relative;
  img {
    position: absolute;
    left: 50%;
    top: 70%;
    transform: translate(-50%, -50%);
    width: 40px;
    filter: drop-shadow(1px 1px 14px black);
    transition: opacity 0.4s linear;
    &.sound {
      opacity: 1;
    }
    &.noOpacity {
      opacity: 0;
    }
  }
`;
